"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseServiceTasks = void 0;
const index_1 = require("../../../../Model/index");
const TypeFactory_1 = require("../../../TypeFactory");
const ActivityFactory_1 = require("./ActivityFactory");
const ExtensionPropertyParser_1 = require("./ExtensionPropertyParser");
function parseServiceTasks(processData) {
    const serviceTasksRaw = (0, TypeFactory_1.getModelPropertyAsArray)(processData, index_1.BpmnTags.TaskElement.ServiceTask);
    const noServiceTasksFound = !((serviceTasksRaw === null || serviceTasksRaw === void 0 ? void 0 : serviceTasksRaw.length) > 0);
    if (noServiceTasksFound) {
        return [];
    }
    const serviceTasks = serviceTasksRaw.map((serviceTaskRaw) => {
        const flowNodeId = serviceTaskRaw.id;
        try {
            return serviceTaskRaw[index_1.BpmnTags.CamundaProperty.Type] === 'external'
                ? parseExternalServiceTask(serviceTaskRaw)
                : parseInternalServiceTask(serviceTaskRaw);
        }
        catch (error) {
            error.additionalInformation = {
                ...error.additionalInformation,
                flowNodeId: flowNodeId,
            };
            throw error;
        }
    });
    return serviceTasks;
}
exports.parseServiceTasks = parseServiceTasks;
function parseExternalServiceTask(serviceTaskRaw) {
    var _a, _b, _c, _d;
    const serviceTask = (0, ActivityFactory_1.createActivityInstance)(serviceTaskRaw, index_1.Model.Activities.ServiceTask);
    serviceTask.type = index_1.Model.Activities.ServiceTaskType.external;
    serviceTask.topic = serviceTaskRaw[index_1.BpmnTags.CamundaProperty.Topic];
    const extensionProperties = (_b = (_a = serviceTask.extensionElements) === null || _a === void 0 ? void 0 : _a.camundaExtensionProperties) !== null && _b !== void 0 ? _b : [];
    serviceTask.payload = (_c = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('payload', extensionProperties)) === null || _c === void 0 ? void 0 : _c.value;
    serviceTask.isSingleTry = ((_d = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('engine.isSingleTry', extensionProperties)) === null || _d === void 0 ? void 0 : _d.value) === 'true';
    return serviceTask;
}
function parseInternalServiceTask(serviceTaskRaw) {
    const serviceTask = (0, ActivityFactory_1.createActivityInstance)(serviceTaskRaw, index_1.Model.Activities.ServiceTask);
    serviceTask.type = index_1.Model.Activities.ServiceTaskType.internal;
    serviceTask.invocation = getMethodInvocationforInternalServiceTask(serviceTask);
    return serviceTask;
}
function getMethodInvocationforInternalServiceTask(serviceTask) {
    var _a, _b, _c;
    const extensionProperties = (_b = (_a = serviceTask.extensionElements) === null || _a === void 0 ? void 0 : _a.camundaExtensionProperties) !== null && _b !== void 0 ? _b : [];
    const moduleProperty = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('module', extensionProperties);
    const methodProperty = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('method', extensionProperties);
    const paramsProperty = (0, ExtensionPropertyParser_1.findExtensionPropertyByName)('params', extensionProperties);
    // 'params' is optional.
    const notAValidMethodInvocation = !moduleProperty || !methodProperty;
    if (notAValidMethodInvocation) {
        return undefined;
    }
    const methodInvocation = new index_1.Model.Activities.Invocations.MethodInvocation();
    methodInvocation.module = moduleProperty.value;
    methodInvocation.method = methodProperty.value;
    methodInvocation.params = (_c = paramsProperty === null || paramsProperty === void 0 ? void 0 : paramsProperty.value) !== null && _c !== void 0 ? _c : '[]';
    return methodInvocation;
}
//# sourceMappingURL=ServiceTaskParser.js.map